import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2dff248c&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=2dff248c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff248c",
  null
  
)

export default component.exports